import React, { FC, ReactNode } from 'react'

import cn from 'classnames'

import classes from './typography.module.scss'
import typographyJson from '../../typography.json'

const typography = typographyJson['typography']

export type TypographyComponent =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'span'
  | 'div'
  | 'li'
  | 'label'

export type TypographyVariant = keyof typeof typography

export interface TypographyProps {
  component?: TypographyComponent
  variant: TypographyVariant
  variantSm?: TypographyVariant
  variantMd?: TypographyVariant
  variantLg?: TypographyVariant
  variantXl?: TypographyVariant
  className?: string
  children: ReactNode
  dataTestId?: string
  htmlFor?: string
}

function toClassName(variant: TypographyVariant): string {
  return `font${String(variant).replace('/', '')}`
}

function toResponsiveClassName(
  prefix: string,
  variant: TypographyVariant
): string {
  const base = toClassName(variant)
  return `${prefix}${base.charAt(0).toUpperCase()}${base.slice(1)}`
}

export const Typography: FC<TypographyProps> = ({
  component: Component = 'p',
  variant,
  variantSm,
  variantMd,
  variantLg,
  variantXl,
  className,
  dataTestId,
  ...props
}) => (
  <Component
    className={cn(
      classes[toClassName(variant)],
      variantSm && classes[toResponsiveClassName('sm', variantSm)],
      variantMd && classes[toResponsiveClassName('md', variantMd)],
      variantLg && classes[toResponsiveClassName('lg', variantLg)],
      variantXl && classes[toResponsiveClassName('xl', variantXl)],
      className
    )}
    data-testid={dataTestId}
    {...props}
  />
)
